import { render, staticRenderFns } from "./SeguroAccidentes.vue?vue&type=template&id=69aa8ede&scoped=true&"
import script from "./SeguroAccidentes.vue?vue&type=script&lang=js&"
export * from "./SeguroAccidentes.vue?vue&type=script&lang=js&"
import style0 from "./SeguroAccidentes.vue?vue&type=style&index=0&id=69aa8ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aa8ede",
  null
  
)

export default component.exports